<template>
  <div class="media-uploader">
    <div class="uploader-content fit-content overflow-auto bg-dashboard-dark-1">
      <div class="media-header bg-dashboard-dark-1 border-outline-dark-bottom">
        <div>
          <h1
            class="d-flex justify-content-start align-items-center text-white"
          >
            <span>Select date &amp; time</span>
          </h1>
        </div>
        <button
          class="btn-close btn-dark"
          @click="close"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Close"
        >
          &times;
        </button>
      </div>
      <div class="media-container p-4 overflow-hidden">
        <v-date-picker
          is-dark
          class="d-block mx-auto"
          :value="selectedDate"
          mode="dateTime"
          trim-weeks
          @input="dateInputChange"
        />
      </div>
      <div class="media-footer bg-dashboard-dark-1 border-outline-dark-top">
        <button
          class="btn btn-outline-secondary btn-sm"
          @click="close"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Click to cancel"
        >
          Cancel
        </button>
        <button
          class="btn btn-info btn-sm"
          @click="dateSelected"
          data-placement="top"
          @mouseover="helper.showTooltip"
          @mouseleave="helper.hideTooltip"
          title="Click to apply"
        >
          Apply
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import helper from "@/helper";

export default {
  name: "date-time-selector",
  props: ["date"],
  data() {
    return {
      selectedDate: null,
      helper: helper,
    };
  },
  methods: {
    dateInputChange(e) {
      this.selectedDate = e;
    },
    dateSelected() {
      if (this.selectedDate === null) {
        Swal.fire("", "Please select valid date", "warning");
      } else {
        this.$emit("close", this.selectedDate);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.selectedDate = this.date;
  },
};
</script>